









































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListKanriHimmoku from '@/components/common/search/ListKanriHimmoku.vue';
import { API_SEARCH_KANRI_HIMMOKU } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlKanriHimmoku',
  components: {
    CtrlSearchBtn,
    CtrlNumTxt,
    ListKanriHimmoku,
  },
  props: {
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '収支管理品目',
    },
    widthCd: {
      type: Number,
      default: 117, //63,
    },
    widthName: {
      type: Number,
      default: 187,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    targetYmd: {
      type: Number,
      required: true,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_KANRI_HIMMOKU,
    listShushiHimmokuShow: false,
    shushiHimmokuCd: 0,
    shushiHimmokuMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { shushiHimmokuCd, shushiHimmokuMei } = item;
      this.shushiHimmokuCd = shushiHimmokuCd;
      this.shushiHimmokuMei = shushiHimmokuMei;
      this.listShushiHimmokuShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listShushiHimmokuShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.shushiHimmokuCd = value;
      if (value) {
        this.getShushiHimmokuItem();
      } else {
        this.shushiHimmokuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk &&
          this.callbackOk({ shushiHimmokuCd: this.shushiHimmokuCd });
      }
    },
    getShushiHimmokuItem() {
      axios
        .get(API_SEARCH_KANRI_HIMMOKU, {
          params: {
            shushiHimmokuCd: this.shushiHimmokuCd,
            targetYmd: this.targetYmd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.shushiHimmokuMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ shushiHimmokuCd: this.shushiHimmokuCd });
            return;
          }
          this.errors = clearNoDataError();
          const { shushiHimmokuMei } = res.data.responseData[0];
          this.shushiHimmokuMei = shushiHimmokuMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [shushiHimmokuCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.shushiHimmokuCd': {
      handler(newValue) {
        if (+newValue === +this.shushiHimmokuCd) return;
        this.shushiHimmokuCd = +newValue;
        if (newValue) {
          this.getShushiHimmokuItem();
        } else {
          this.shushiHimmokuMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.shushiHimmokuCd) {
      this.shushiHimmokuCd = +this.$attrs.shushiHimmokuCd;
    }
  },
});
